module.exports = __webpack_public_path__ + "img/communication.a98f3147.svg";